import wrapper from "./wrapper.html";
import "./style.less";
import { FORM_ENTITIES } from "../../../../routes";
import {
	EVENT_LOAD_OPTIONS,
	EVENT_TIMEZONE_SET, 
	PROXY_FIELDS 
} from "../../../../constants";
import { uuid } from "../../../../utils";

class EntityController {
	constructor($scope, eventBus, appState, $logger, loadingService, api) {
		this._scope = $scope;
		this.eventBus = eventBus;
		this.form = appState.forms.selected;
		this.logger = $logger;
		this.loadingService = loadingService;
		this.api = api;
		this.appState = appState;
		this.entitySelectorFieldId = uuid();
	}

	$onChanges(changes) {
		if(changes.ngModel && !changes.ngModel.currentValue) {
			if(this.entitySelector) {
				this.entitySelector.clearSelected();
			}
		}
	}

	$onInit() {
		this.form = this.appState.forms.selected;

		this.loadEntities();
	}

	onSelectorCallbacks = (selector) => {
		this.entitySelector = selector;
	}

	loadEntities = () => {
		const params = [this.schema.configuration];
		const promise = this.api
			.post(FORM_ENTITIES(this.form.Id), params)
			.then((entities) => {
				this.associatedEntities = entities[0].Entities;
				this.eventBus.trigger(EVENT_LOAD_OPTIONS(this.entitySelectorFieldId), { entities: this.associatedEntities });
			})
			.catch(() => {
				this.associatedEntities = [];
				this.eventBus.trigger(EVENT_LOAD_OPTIONS(this.entitySelectorFieldId), { entities: [] });
			});

		this.loadingService.watch(promise);
	}

	onChanged = (item) => {
		if(item === undefined) {
			this.ngModelCtrl.$setViewValue(undefined);

			return;
		}

		const subjectEntity = this.schema.configuration.RelationshipType.Code === "SELF" ? item.friendly : item.primary;
		const modelValue = subjectEntity[this.schema.modelProperty];

		if(this.form.TimeMode?.Code === "BYENTITY" && subjectEntity.TimeZone !== undefined) {
			this.eventBus.trigger(
				EVENT_TIMEZONE_SET(PROXY_FIELDS.DATETIME),
				{ value: subjectEntity.TimeZone.Code }
			);
		}

		this.ngModelCtrl.$setViewValue(modelValue);
	}
}

export default angular
	.module("vesl.extensions.json-schema.entity.controller", [])
	.component("entityAddOn", {
		controller: EntityController,
		template: wrapper,
		require: { ngModelCtrl: "^ngModel" },
		bindings: {
			schema: "<",
			ngModel: "<"
		}
	}).name;
